import { Injectable } from '@angular/core';

import { NumpadDisplayService } from 'packages/sports/web/app/src/numpad/numpad-display.service';
import { Observable, distinctUntilChanged, filter, map, merge, startWith } from 'rxjs';

import { QUICK_BET_NUMPAD } from '../../stake/models';

@Injectable({ providedIn: 'root' })
export class QuickBetNumpadService {
    readonly quickBetNumpadOpen$: Observable<boolean>;

    constructor(displayService: NumpadDisplayService) {
        this.quickBetNumpadOpen$ = merge(
            displayService.open$.pipe(
                filter((options) => options.id === QUICK_BET_NUMPAD),
                map(() => true),
            ),
            displayService.close$.pipe(map(() => false)),
        ).pipe(distinctUntilChanged(), startWith(false));
    }
}
